import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

type PageHeaderProps = {
  title: string;
  description?: React.ReactNode;
  actions?: React.ReactNode;
};

/** Compact page title block used across cabinet and ops screens. */
const PageHeader: React.FC<PageHeaderProps> = ({ title, description, actions }) => (
  <Stack
    direction={{ xs: 'column', sm: 'row' }}
    justifyContent="space-between"
    alignItems={{ xs: 'stretch', sm: 'flex-start' }}
    spacing={1}
    sx={{ mb: 1.5 }}
  >
    <Box sx={{ minWidth: 0 }}>
      <Typography variant="h5" sx={{ mb: description ? 0.35 : 0 }}>
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ wordBreak: 'break-word' }}>
          {description}
        </Typography>
      )}
    </Box>
    {actions && (
      <Stack
        direction="row"
        spacing={1}
        flexWrap="wrap"
        useFlexGap
        sx={{ flexShrink: 0, maxWidth: '100%' }}
      >
        {actions}
      </Stack>
    )}
  </Stack>
);

export default PageHeader;
